import React from 'react'
import { Route } from 'react-router-dom'

const PublicWebRoutes = ({ userInfo = '', component: Component, ...rest }) => {
      return <Route {...rest} render={() => <Component />} />
}

export default PublicWebRoutes
